export default __webpack_public_path__ + "static/media/diagram.c162ca45.svg";